import React, { useEffect, useState } from 'react'
import { useAuth } from '../components/AuthProvider'
import { getActiveOrgId } from '../utils/orgUtils'
import { pageScope } from '../lib/cssScope'
import { Button } from '../components/ui/Button'

interface ScanRequest {
  id: string
  targets: any
  status: string
  createdAt?: string
  reportId?: number|null
}

const ScanRequests: React.FC = () => {
  const { token, user } = useAuth()
  const [items, setItems] = useState<ScanRequest[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string|null>(null)

  const load = async () => {
    setLoading(true); setError(null)
    try {
      const orgId = getActiveOrgId()
      const url = orgId ? `/api/scans/requests?organization_id=${encodeURIComponent(orgId)}` : '/api/scans/requests'
      const res = await fetch(url, { headers: { 'Authorization': `Bearer ${token}` } })
      if (!res.ok) throw new Error('Failed to load scan requests')
      const dto = await res.json()
      setItems(Array.isArray(dto.requests) ? dto.requests : [])
    } catch (e:any) {
      setError(e.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(()=>{ load() }, [])

  return (
    <div className={`${pageScope('scan-requests')} p-6 space-y-4`}>
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">Scan Requests</h1>
        <Button type="button" color="secondary" size="small" className="px-3 py-1.5 rounded text-sm" onClick={load}>Refresh</Button>
      </div>
      {error && <div className="text-red-600 text-sm">{error}</div>}
      {loading ? <div>Loading...</div> : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-left">
                <th className="px-3 py-2">ID</th>
                <th className="px-3 py-2">Targets</th>
                <th className="px-3 py-2">Status</th>
                <th className="px-3 py-2">Created</th>
                <th className="px-3 py-2">Report</th>
              </tr>
            </thead>
            <tbody>
              {items.map(it => (
                <tr key={it.id} className="border-t">
                  <td className="px-3 py-2 font-mono">{it.id}</td>
                  <td className="px-3 py-2">
                    {Array.isArray(it.targets) ? it.targets.join(', ') : (it.targets === 'ALL' ? 'ALL' : JSON.stringify(it.targets))}
                  </td>
                  <td className="px-3 py-2">{it.status}</td>
                  <td className="px-3 py-2">{it.createdAt ? new Date(it.createdAt).toLocaleString() : ''}</td>
                  <td className="px-3 py-2">{it.reportId ? `#${it.reportId}` : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default ScanRequests
